import { dapRedirectCommon } from '~/data/common/config/redirect'
export let dapRedirect = Object.freeze(deepMerge(dapRedirectCommon, {
  // 日本語
  '/about-terms': '/about/terms',
  '/cooperation-faq': '/cooperation/faq',
  '/policy-privacy': '/policy/privacy',
  '/policy/available_rights_statements': '/policy/available-rights-statements',
  '/api': '/static/developer/ja.html',
  '/api/introduction': '/static/developer/introduction/ja.html',
  '/api/property_access-source': '/static/developer/property_access-source/ja.html',
  '/api/property_normalization': '/static/developer/property_normalization/ja.html',
  '/api/property_simple': '/static/developer/property_simple/ja.html',
  '/api/property_structured': '/static/developer/property_structured/ja.html',
  '/api/webapi': '/static/developer/webapi/ja.html',
  '/api/webparts': '/static/developer/webparts/ja.html',
  '/api/sparql-explain': '/rdf/sparql-explain/',
  '/api/jps.shex': '/static/developer/jps.shex',
  '/static/devloper/webparts': '/static/developer/webparts/ja.html',
  // 英語
  '/en/about-terms': '/en/about/terms',
  '/en/cooperation-faq': '/cooperation/faq',
  '/en/policy-privacy': '/en/policy/privacy',
  '/en/policy/available_rights_statements': '/en/policy/available-rights-statements',
  '/en/api': '/static/developer/en.html',
  '/en/api/introduction': '/static/developer/introduction/en.html',
  '/en/api/property_access-source': '/static/developer/property_access-source/en.html',
  '/en/api/property_normalization': '/static/developer/property_normalization/en.html',
  '/en/api/property_simple': '/static/developer/property_simple/en.html',
  '/en/api/property_structured': '/static/developer/property_structured/en.html',
  '/en/api/webapi': '/static/developer/webapi/en.html',
  '/en/api/webparts': '/static/developer/webparts/en.html',
  '/en/api/sparql-explain': '/rdf/sparql-explain/',
  '/en/api/jps.shex': '/static/developer/jps.shex',
  '/en/static/devloper/webparts': '/static/developer/webparts/en.html',
}))
